export default "__VITE_ASSET__Dh$op7Rx__"